import React, { useState, useEffect, useRef } from "react";
import { ReactComponent as EditIcon } from "../../img/editicon.svg";
import { ReactComponent as TrashIcon } from "../../img/trashicon.svg";
import {instance2} from '../../utils/axiosInstance'
import { ReactComponent as VerticalLine } from '../../img/verticalline.svg'
import { ReactComponent as MagnificationLogo } from '../../img/magnificationlensicon.svg'
import { ReactComponent as BackButton } from "../../img/bacbuttonicon.svg";

export default function TambahDapur(){

  
    const locationId = localStorage?.getItem("locationId")
    const [formData, setFormData] = useState({
      name: "",
      location_id: "",
      description: "",
      admin_id: "",
      kitchen_head: "",
      phone: "",
      address: "",
    });
    const [searchTerm, setSearchTerm] = useState("");
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [error, setError] = useState(null);
    const [successMessage, setSuccessMessage] = useState("");
    const [userId, setUserId] = useState("");
    const [location, setLocation] = useState([]); // Storage locations
    const [loading, setLoading] = useState(true); // Loading state
    const [user, setUser] = useState("");
    // Modal States
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [editRowData, setEditRowData] = useState(null);
    const [isDropdownModalOpen, setIsDropdownModalOpen] = useState(false);
    const [modalSearchTerm, setModalSearchTerm] = useState(""); // Modal-specific search term
    const [modalFilteredLocations, setModalFilteredLocations] = useState([]); // Modal-specific filtered locations
      const [searchQuery, setSearchQuery] = useState(""); // State for search input


      const roleId = parseInt(localStorage.getItem('roleId'),10); 
        const dropdownRef = useRef(null); // Ref to track dropdown
  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setError(null);
    setSuccessMessage("");
  
    try {
      const response = await instance2.post("kitchen", formData);
  
      setSuccessMessage("Kitchen created successfully!");
      setFormData({
        name: "",
        location_id: "",
        description: "",
        admin_id: user, // Reset admin_id to current user
      });
      window.history.back()
    } catch (err) {
      setError(err.response?.data?.message || "Failed to create Kitchen. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };

useEffect(() => {
    const fetchLocation = async () => {
      try {
        const response = await instance2.get("location"); // Use instance2 for the API call
  
        const locationData = response.data; // Access the data property from Axios response
  
        setLocation(
          locationData.map((loc) => ({
            id: loc.id,
            name: loc.location_name,
            code: loc.code,
          }))
        );
      } catch (err) {
        console.error("Failed to fetch locations", err);
        setError(err.response?.data?.message || "Failed to fetch storage locations");
      } finally {
        setLoading(false);
      }
    };
  
    fetchLocation();
  }, []);
  const filteredLocations = location.filter((loc) =>
    loc.name.toLowerCase().includes(searchTerm.toLowerCase())
  );
  
useEffect(() => {
  const storedUser = localStorage.getItem('userAuthentication');
  if (storedUser) {
    setUser(storedUser);
  }

  const storedUserId = localStorage.getItem("userId");
  if (storedUserId) {
    setUserId(parseInt(storedUserId, 10));
    setFormData((prev) => ({
      ...prev,
      admin_id: storedUser, // use the string or parse as needed
    }));
  }

  // If roleId is 4, assign the locationId automatically
  if (roleId !== 1) {
    const locId = localStorage.getItem("locationId");
    if (locId) {
      setFormData((prev) => ({
        ...prev,
        location_id: locId,
      }));
    }
  }
}, []);



  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };


    return(
        <div className="p-4"><div>
    <h2 className="text-lg font-bold mb-4">Tambah Dapur</h2>
    <form onSubmit={handleSubmit}>
    <div className="flex flex-row gap-4">
    <div className="flex flex-col w-full">
      {/* Name */}
      <div className="mb-4">
        <label className="block text-gray-700 mb-2">Nama Dapur</label>
        <input
          type="text"
          name="name"
          value={formData.name}
          onChange={handleChange}
          className="w-full px-3 border-none rounded-full bg-white text-xs py-4"
          placeholder="Masukkan Nama Dapur"
          required
        />
      </div>
      <div className="mb-4">
        <label className="block text-gray-700 mb-2">Kepala SPPG</label>
        <input
          type="text"
          name="kitchen_head"
          value={formData.kitchen_head}
          onChange={handleChange}
          className="w-full px-3 border-none rounded-full bg-white text-xs py-4"
          placeholder="Masukkan Nama Kepala SPPG"
          required
        />
      </div>
      <div className="mb-4">
        <label className="block text-gray-700 mb-2">Alamat</label>
        <input
          type="text"
          name="address"
          value={formData.address}
          onChange={handleChange}
          className="w-full px-3 border-none rounded-full bg-white text-xs py-4"
          placeholder="Masukkan Alamat"
          required
        />
      </div>
      

      {loading ? (
        <p>Loading...</p>
      ) : error ? (
        <p className="text-red-500">{error}</p>
      ) : (
        <>

        
          {/* Location ID */}
{roleId === 1 ? (
  // Admin: Editable dropdown
  <div className="mb-4 relative" ref={dropdownRef}>
    <label className="block text-gray-700 mb-2">Koperasi</label>
    <div className="relative">
      <input
        type="text"
        placeholder="Pilih Koperasi"
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        onFocus={() => setIsDropdownOpen(true)}
        className="w-full px-3 border-none rounded-full bg-white text-xs py-4 focus:outline-none"
      />
      <div
        className="absolute inset-y-0 right-3 flex items-center cursor-pointer"
        onClick={() => setIsDropdownOpen((prev) => !prev)}
      >
        <svg
          className={`w-4 h-4 transition-transform ${isDropdownOpen ? "rotate-180" : "rotate-0"}`}
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
        </svg>
      </div>
    </div>
    {isDropdownOpen && (
      <div className="absolute z-10 bg-white border rounded-lg w-full max-h-40 overflow-y-auto shadow-lg mt-1">
        {filteredLocations.length > 0 ? (
          filteredLocations.map((loc) => (
            <div
              key={loc.id}
              className="px-4 py-2 text-sm cursor-pointer hover:bg-gray-100"
              onClick={() => {
                setFormData({ ...formData, location_id: loc.id });
                setSearchTerm(loc.name);
                setIsDropdownOpen(false);
              }}
            >
              {loc.name}
            </div>
          ))
        ) : (
          <div className="px-4 py-2 text-sm text-gray-500">No locations found</div>
        )}
      </div>
    )}
  </div>
) : (
  // Staff: Read-only display
  <div className="mb-4">
    <label className="block text-gray-700 mb-2">Koperasi</label>
    <input
      type="text"
      value={
        location.find((loc) => loc.id.toString() === formData.location_id)?.name || "Loading..."
      }
      readOnly
      className="w-full px-3 border-none rounded-full bg-gray-100 text-xs py-4 cursor-not-allowed"
    />
  </div>
)}


        </>
      )}
            </div>
            
    <div className="flex flex-col w-full">

      {/* Jumlah Siswa */}
      <div className="mb-4">
        <label className="block text-gray-700 mb-2">Jumlah Porsi</label>
       <input
  type="number"
  name="kitchen_pack"
  value={formData.kitchen_pack}
  onChange={handleChange}
  className="w-full px-3 border-none rounded-full bg-white text-xs py-4"
  placeholder="Jumlah Siswa"
  min="0"
/>

      </div>

      <div className="mb-4">
        <label className="block text-gray-700 mb-2">Nomor Telepon Kepala SPPG</label>
        <input
          type="tel"
          name="phone"
          value={formData.phone}
          onChange={handleChange}
              onInput={(e) => {
                e.target.value = e.target.value.replace(/[^0-9\-\+\(\)\s]/g, "");
              }}
          className="w-full px-3 border-none rounded-full bg-white text-xs py-4"
          placeholder="Masukkan Nomor Telepon"
          required
        />
      </div>

      {/* Description */}
      <div className="mb-4">
        <label className="block text-gray-700 mb-2">Deskripsi</label>
        <textarea
          name="description"
          value={formData.description}
          onChange={handleChange}
          className="w-full px-3 border-none rounded-full bg-white text-xs py-4"
          placeholder="Masukkan Deskripsi"
          required
        ></textarea>
      </div>

      </div>
      </div>

      {/* Submit Button */}
      <div className="flex justify-end">
        <button
          type="submit"
          className={`px-4 py-2 bg-merah-no text-white rounded hover:bg-merah-hover ${
            isSubmitting && "opacity-50 cursor-not-allowed"
          }`}
          disabled={isSubmitting}
        >
          {isSubmitting ? "Menyimpan..." : "Simpan"}
        </button>
      </div>
    </form>

    {/* Success Message */}
    {successMessage && <p className="text-green-500 mt-4">{successMessage}</p>}

    {/* Error Message */}
    {error && <p className="text-red-500 mt-4">{error}</p>}
    

    
    <div className="flex py-2 rounded-[50px] flex-row justify-start items-center gap-2 w-full md:w-auto">

</div>
</div>
        </div>
    )
}